import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 18px 0;
  justify-content: space-between;
  align-items: center;
  background-color: #FAFAFA;
  @media (max-width: 1000px) {
    margin: 0 30px;
  }
  @media(max-width: 600px){
    margin:  0px;
  }
`;

export const Line = styled.div`
  width:  100px;
  height: 3px;
  background-size: cover;
  background-image: url("/images/icons/Rectangle 36.png");
`;

export const Heading = styled.h1`
  margin: 0;
  font-family: NunitoSans-Bold;
  font-style: normal;
  font-weight: 700;
  font-size: 30px;
  line-height: 65.47px;
  letter-spacing: 1.5px;

  /* black */

  color: #000000;
  @media(max-width: 600px){
    font-size: 24px;
    line-height: 33px;
    text-align: center;
   }
`;

export const SubHeading = styled.h2`
  margin: 0;
  font-family: NunitoSans-SemiBold;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 0.5px;

  /* secondary Dark */

  color: #d67723;
  @media(max-width: 600px){
    font-size: 16px;
    line-height: 30px;
    text-align: center;
   }
`;

export const Text = styled.p`
  margin: 0;
  font-family: NunitoSans-SemiBold;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  text-align:center;
  line-height: 32.74px;
  display: flex;
  flex-wrap: wrap;
  /* or 167% */

  letter-spacing: 1.5px;

  /* grey 900 */

  color: #4f4f4f;
  @media(max-width: 600px){
    font-size: 14px;
    line-height: 30px;

  }
`;

export const Logo = styled.img`
  width: 135px;
  height: 135px;
  color: #d67723;
  @media(max-width: 600px){
    width: 90px;
    height: 90px;
   }
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
`;

export const Pane = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 122px;
  padding: 10px;
  border-radius: 12px;
  @media (max-width: 1000px) {
    width: 100%;
    padding: 0 45px;
    text-align: center;
  }
  &:hover {
    background-color: #fafafa;
  }
  @media(max-width: 600px){
    width: 150px;
    padding: 5px;
  }
`;

export const Frame = styled.div`
  display: flex;
  padding: 18px 0;
  width: 100%;
  flex-wrap: wrap;
  justify-content: space-evenly;

  @media(max-width: 600px){
    flex-direction: row;
    justify-content: space-around;
  }
`;
